import { useQuery } from '@tanstack/react-query';

import { services } from '../../services';

export const useGetAutomationOrder = ({ code, orderCode }, options = {}) =>
  useQuery(['automationOrder', code, orderCode], () => services.orderDetail(code, orderCode), {
    staleTime: 20 * 1000,
    ...options
  });
